import React, { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext();

export function useCart() {
  return useContext(CartContext);
}

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      const raw = localStorage.getItem("nava_cart");
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem("nava_cart", JSON.stringify(items));
    } catch (e) {}
  }, [items]);

  const addItem = (item) => {
    setItems((prev) => {
      const copy = prev.map((p) => ({ ...p }));
      const idx = copy.findIndex((p) => p.srvId?.toString() === item.srvId?.toString());
      if (idx >= 0) {
        copy[idx].quantity = (Number(copy[idx].quantity) || 0) + (Number(item.quantity) || 1);
      } else {
        copy.push({ ...item, quantity: Number(item.quantity) || 1 });
      }
      return copy;
    });
  };

  const setQuantity = (srvId, qty) => {
    setItems((prev) => prev.map((p) => (p.srvId?.toString() === srvId?.toString() ? { ...p, quantity: Math.max(0, Number(qty) || 0) } : p)).filter(p => p.quantity > 0));
  };

  const removeItem = (srvId) => {
    setItems((prev) => prev.filter((p) => p.srvId?.toString() !== srvId?.toString()));
  };

  const clear = () => setItems([]);

  const total = items.reduce((acc, i) => acc + (Number(i.price) || 0) * (Number(i.quantity) || 0), 0);

  return (
    <CartContext.Provider value={{ items, addItem, setQuantity, removeItem, clear, total }}>
      {children}
    </CartContext.Provider>
  );
}
